import { Outlet } from 'react-router';

import { useResetViewStateOnSectionLeave } from '@/hooks/useResetViewStateOnSectionLeave';

import { cn } from '@/utils/tailwind';

import DocumentHeader from './Header/DocumentHeader';

import { useGameFullscreen } from '@/atoms/document-transient';
import { useIsTridionTraining } from '@/routes/TrainingPlans/hooks/useIsTridionTraining';

export default function DocumentLayout() {
  useResetViewStateOnSectionLeave('/document');
  const [isGameFullscreen] = useGameFullscreen();

  const { docProxy, planName, planId, isTrainingMode, isTridion } =
    useIsTridionTraining();

  return (
    <>
      <DocumentHeader
        name={docProxy?.name}
        planName={planName}
        planId={planId}
        isTrainingMode={isTrainingMode}
        isTridion={isTridion}
      />
      <div
        className={cn(
          'md:mt-header-height mx-auto flex w-full justify-center pt-4 md:px-4',
          {
            'pt-0': isGameFullscreen,
          },
        )}
      >
        <Outlet />
      </div>
    </>
  );
}
